import { createSelector } from 'reselect';
import { getEntities } from './utils';

const getBuyerFormFields = createSelector(getEntities, entities => entities.formFields);
const getBuyer = createSelector(getEntities, entities => entities.buyer);

export {
  getBuyerFormFields,
  getBuyer,
};
